import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import $ from 'jquery';

const Lnb: React.FC = () => {
    const currentLoc = useLocation();
    let pathNameSplit = currentLoc.pathname.split('/');
    const firstPathName = pathNameSplit[1].replaceAll("/", "");
    const lastPathName = pathNameSplit[2].replaceAll("/", "");
    const handleH2Click = (e: React.MouseEvent<HTMLHeadingElement>) => {
        if ("on" === e.currentTarget.className) {
            $(e.currentTarget).removeClass("on");
            $(e.currentTarget).next().slideUp();
        } else {
            $(e.currentTarget).parent().siblings("div").find("h2").next().slideUp();
			$(".lnb h2").removeClass("on");
            $(e.currentTarget).addClass("on");
            $(e.currentTarget).next().slideDown();
        }
    }

    const handleResize = () => {
        if (window.innerWidth < 820) {
            $(".lnb >div").each(function (e) {
                let lnbDepth = $(this).attr("class");
                if ("therapy" !== lnbDepth) {
                    $(this).css("display", "block");
					$(this).find("h2").css("display", "block");
                } else {
                    $(this).css("display","block");
                    $(this).find("h2").attr("class", "on");
                    $(this).find("ul").css("display", "block");
                }
            });
        } else if (window.innerWidth > 819) {
            $("#warp").css({"width":"100%", "margin-left": "0px"});
            $(".lnb >div").each(function (e) {
                let lnbDepth = $(this).attr("class");
                if (lnbDepth !== "therapy") {
                    $(this).css("display","none");
                    $(this).find("h2").css("display", "none");
                    $(this).find("ul").css("display", "none");
                } else {
                    $(this).css("display", "block");
                    $(this).find("h2").css("display", "block");
                    $(this).find("ul").css("display", "block");
                }
            });
        }
    }

	const handleUrl = (uri: string) => {
		window.location.href = process.env.REACT_APP_API_URL + uri;
	}

    useEffect(() => {
        if (window.innerWidth < 820) {
            $(".lnb >div").each(function (e) {
                $(this).css("display","block");
                $(this).find("h2").css("display", "block");
            });
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);

    return (
        <nav id="lnb" className="lnb">
            <div className="menu"></div>
            <div className="service" style={{display: "none"}}>
				<h2 onClick={handleH2Click}>서비스 안내</h2>
				<ul>
					<li>
						<a href="#" onClick={() => handleUrl("/service/service_healthcare.asp")}>헬스케어서비스 소개</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/service/service_healthcare.asp")}>헬스케어서비스</a></li>
							<li><a href="#" onClick={() => handleUrl("/service/service_premier.asp")}>프리미어 헬스케어서비스</a></li>
						</ul>
					</li>
					<li><a href="#" onClick={() => handleUrl("/service/service_faq.asp")}>자주 묻는 질문</a></li>
					<li><a href="#" onClick={() => handleUrl("/service/service_afterlist.asp")}>서비스 체험수기</a></li>
				</ul>
			</div>
            <div className="util" style={{display: "none"}}>
				<h2 onClick={handleH2Click}>서비스 이용</h2>
				<ul>
					<li>
						<a href="#" onClick={() => handleUrl("/util/util_CounselUp.asp")}>평상시 건강관리</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/util/util_CounselUp.asp")}>건강상담</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_CounselUpInfo.asp")}>건강정보 제공</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_CounselUpMobile.asp")}>모바일 APP </a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/util/util_VisitingCare.asp")}>가족 건강관리</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/util/util_VisitingCare.asp")}>미숙아 방문간호 컨설팅</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_ReservationInfo.asp")}>건강검진 안내 &amp; 우대 예약</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_CancerInfo.asp")}>암 정보 제공</a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/util/util_DoctorInfo.asp")}>일반 치료지원</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/util/util_DoctorInfo.asp")} className="ls1">병원•의료진 안내 및 예약 대행</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_CoachingCall.asp")}>1:1 코칭콜</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_PsyCounsel.asp")}>심리상담</a></li>
						</ul>
					</li>
					<li> 
						<a href="#" onClick={() => handleUrl("/util/util_NurseWith.asp")}>중대질환 치료지원</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/util/util_NurseWith.asp")} className="ls1">간호사 병원동행 / 질병관리교육</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_CancerPrevent.asp")}>암 재발 예방</a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/util/util_healthPDS_main.asp")}>프리미어 헬스케어서비스</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/util/util_healthPDS_main.asp")}>건강증진 프로그램</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_Premier.asp")}>차량 에스코트</a></li>
							<li><a href="#" onClick={() => handleUrl("/util/util_PremierForeign.asp")}>해외 의료지원</a></li>
						</ul>
					</li>
				</ul>
			</div>
            <div className="check" style={{display: "none"}}>
				<h2 onClick={handleH2Click}>건강체크</h2>
				<ul>
					<li><a href="#" onClick={() => handleUrl("/check/check_HealthUp.asp")}>헬스업 프로그램</a></li>
					<li>
						<a href="#" onClick={() => handleUrl("/check/check_healthGraph_Weight.asp")}>건강그래프</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthGraph_Weight.asp")}>비만도</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthGraph_Blood.asp")}>혈압</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthGraph_Sugar1.asp")}>혈당</a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp")}>1:1 코칭콜</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp?n=1")}>스트레스</a></li>
							<li><a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp?n=2")}>금연</a></li>
							<li><a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp?n=3")}>절주</a></li>
							<li><a href="#" onClick={() => handleUrl("/coaching/coaching_CoachingCall_main.asp?n=4")}>운동/영양</a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/check/check_healthPDS_main.asp")}>건강증진 프로그램</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Stress.asp")}>스트레스</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Skin.asp")}>피부관리</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Weight.asp")}>비만</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Smoking.asp")}>금연</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Drinking.asp")}>절주</a></li>
							<li><a href="#" onClick={() => handleUrl("/check/check_healthPDS_Menopause.asp")}>갱년기</a></li>
						</ul>
					</li>
				</ul>
			</div>
            <div className="reference" style={{display: "none"}}>
				<h2 onClick={handleH2Click}>건강자료실</h2>
				<ul>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_info_main.asp")}>한 눈에 보는 건강정보</a></li>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_premier_list.asp")}>프리미어 고객 건강정보</a></li>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_dental_list.asp")}>치아건강</a></li>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_expert_list.asp")}>전문의에게 듣는 건강상식</a></li>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_news_list.asp")}>건강뉴스</a></li>
					<li><a href="#" onClick={() => handleUrl("/reference/reference_newsletter_list.asp")}>건강뉴스레터</a></li>
				</ul>
			</div>
            <div className="therapy">
                <h2 onClick={handleH2Click}>토닥토닥마음케어</h2>
                <ul>
                    <li className={firstPathName === "column" ? "current" : ""}>
                        <Link to="/column/columnList">전문심리칼럼</Link>
                    </li>
                    <li className={firstPathName === "psychlgclCheck" ? "current" : ""}>
                        <Link to="/psychlgclCheck/main">무료심리검사</Link>
                        <ul>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "stress" ? "current" : ""}>
                                <Link to="/psychlgclCheck/stress">스트레스 자가진단</Link>
                            </li>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "depression" ? "current" : ""}>
                                <Link to="/psychlgclCheck/depression">우울 자가진단</Link>
                            </li>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "anxiety" ? "current" : ""}>
                                <Link to="/psychlgclCheck/anxiety">불안 자가진단</Link>
                            </li>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "angry" ? "current" : ""}>
                                <Link to="/psychlgclCheck/angry">화병 성격척도</Link>
                            </li>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "traumatic" ? "current" : ""}>
                                <Link to="/psychlgclCheck/traumatic">외상 후 스트레스</Link>
                            </li>
                            <li className={firstPathName === "psychlgclCheck" && lastPathName === "happy" ? "current" : ""}>
                                <Link to="/psychlgclCheck/happy">행복 자가진단</Link>
                            </li>
                        </ul>
                    </li>
                    <li className={firstPathName === "healingContent" ? "current" : ""}>
                        <Link to="/healingContent/main">힐링컨텐츠</Link>
                    </li>
                    <li className={firstPathName === "psychgclCounsel" ? "current" : ""}>
                        <Link to="/psychgclCounsel/counselMain">제휴심리상담센터</Link>
                    </li>
                </ul>
            </div>
            <div className="mypage" style={{display: "none"}}>
				<h2 onClick={handleH2Click}>마이페이지<span></span></h2>
				<ul>
					<li><a href="#" onClick={() => handleUrl("/myPage/myPage_info.asp")}>회원정보</a></li>
					<li>
						<a href="#" onClick={() => handleUrl("/myPage/myPage_CounselList.asp")}>서비스 이용내역</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/myPage/myPage_CounselList.asp")}>온라인상담내역</a></li>
							<li><a href="#" onClick={() => handleUrl("/myPage/myPage_CallList.asp")}>전화상담내역</a></li>
							<li><a href="#" onClick={() => handleUrl("/myPage/myPage_ReserveList.asp")}>건강검진예약내역</a></li>
						</ul>
					</li>
					<li>
						<a href="#" onClick={() => handleUrl("/mypage/myPage_HealthUpList.asp")}>건강체크 내역</a>
						<ul>
							<li><a href="#" onClick={() => handleUrl("/mypage/myPage_HealthUpList.asp")}>헬스업 프로그램</a></li>
							<li><a href="#" onClick={() => handleUrl("/mypage/myPage_HealthPDSList.asp")}>건강증진 프로그램</a></li>
							<li><a href="#" onClick={() => handleUrl("/myPage/myPage_CoachingCallList.asp")}>1:1 코칭콜 프로그램</a></li>
						</ul>
					</li>
					<li><a href="#" onClick={() => handleUrl("/mypage/myPage_ReservationResult.asp")}>건강검진 결과</a></li>
				</ul>
			</div>
            <aside>
				<div className="call">
					<p className="phone">헬스콜센터<span>1588-7524</span></p>
					<p className="day">평일 09:00~19:00<br />토요일 09:00~13:00</p>
				</div>
				<div className="void"></div>
			</aside>
        </nav>
    )
}

export default Lnb;